import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgClass } from '@angular/common';
import { ComplaintChannelComponent } from './modals/complaint-channel/complaint-channel.component';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [RouterModule, NgClass],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent {
  openSection: string | null = null;

  constructor(private modalService: NgbModal) {}

  toggleSection(section: string) {
    this.openSection = this.openSection === section ? null : section;
  }

  openComplaintModal(event: Event) {
    event.preventDefault();
    this.modalService.open(ComplaintChannelComponent, {
      centered: true,
      size: 'lg',
      backdrop: 'static',
    });
  }
}